import React, {useEffect} from 'react'
import {useCustomPreference} from '../../hooks/use-custom-preference'
import {useLocation} from 'react-router-dom'

const Digioh = () => {
    const digiohVendorUrl = useCustomPreference('digiohVendorURL')
    const location = useLocation()

    const url = `${digiohVendorUrl}?v=${location.pathname}`

    useEffect(() => {
        if (digiohVendorUrl) {
            const script = document.createElement('script')
            script.type = 'text/javascript'
            script.src = url
            script.id = 'digioh-script'
            script['data-testid'] = 'digioh-script'
            script.async = true
            document.head.appendChild(script)
        }
    }, [])

    return <></>
}

export default Digioh
